export function getFeatureActive(flag: string): boolean {
  const config = useRuntimeConfig()

  const configKey = `feat${flag}`

  if (!config.public[configKey]) return false

  return config.public[configKey] === 'true'
}
